import { Node } from "./node";

export class Delay {
  id: number;
  flowId: number;
  seconds: number;
  unit: string;
  node: Node;
}
